import { render, staticRenderFns } from "./NewConsortiumModal.vue?vue&type=template&id=52c448dc&"
import script from "./NewConsortiumModal.vue?vue&type=script&lang=js&"
export * from "./NewConsortiumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports